import { ObjectId } from "bson";
import { Map, MapImage, MapShape, Token, TurnOrder } from "./mapReducer";

const setMapBackground = (value: string) => ({
    type: 'MAP/SET_BACKGROUND',
    value,
});

const setMapValues = (value: Partial<Map>) => ({
    type: 'MAP/SET_PARTIAL',
    value,
});

const setMapId = (value: string) => ({
    type: 'MAP/SET_MAPID',
    value,
});

const resetMap = () => ({
    type: 'MAP/RESET',
});

const setTokens = (value: Token[]) => ({
    type: 'MAP/SET_TOKENS',
    value,
});

const setFog = (value: boolean[][]) => ({
    type: 'MAP/SET_FOG',
    value,
});

const setTurnOrder = (value: TurnOrder[]) => ({
    type: 'MAP/SET_TURN_ORDER',
    value,
});

const setActiveTurn = (value: string | undefined) => ({
    type: 'MAP/SET_ACTIVE_TURN',
    value,
});

const setFogShape = (value: { type: string, size: number, add: boolean } | undefined) => ({
    type: 'MAP/SET_FOG_SHAPE',
    value,
});

const setMapImages = (value: MapImage[]) => ({
    type: 'MAP/SET_IMAGES',
    value,
});

const setMapSpells = (value: MapShape[]) => ({
    type: 'MAP/SET_SPELLS',
    value,
});

const setMapLoading = (value: boolean) => ({
    type: 'MAP/SET_LOADING',
    value,
});

const toggleLayer = () => ({
    type: 'MAP/TOGGLE_LAYER',
});


const setMode = (value: 'default' | 'pan' | 'measure') => ({
    type: 'MAP/SET_MODE',
    value,
});

const setSelectedElement = (value: { _id: ObjectId, type: string} | undefined) => ({
    type: 'MAP/SET_SELECTED_ELEMENT',
    value,
});

const addPing = (value: { x: number, y: number, _id: ObjectId }) => ({
    type: 'MAP/ADD_PING',
    value,
});

const removePing = (value: ObjectId) => ({
    type: 'MAP/REMOVE_PING',
    value,

});

export {
    setMapBackground,
    setMapLoading,
    setMapImages,
    resetMap,
    setMapId,
    setTokens,
    setMapSpells,
    toggleLayer,
    setMode,
    setSelectedElement,
    addPing,
    removePing,
    setFog,
    setFogShape,
    setTurnOrder,
    setActiveTurn,
    setMapValues,
};
